// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"717d509b","453":"01dce86c"}[chunkId] + ".chunk.js";
};